<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">{{ dialogTitle }}</h2>
      <button class="close-btn" (click)="onCancel()">×</button>
    </div>

    <div class="modal-body">
      <p class="confirmation-message">{{ message }}</p>
    </div>

    <div class="modal-footer">
      @if (cancelLabel) {
      <button type="button" class="btn btn-outline" (click)="onCancel()">{{ cancelLabel }}</button>
      }
      <button type="button" class="btn" [class.btn-primary]="!isDanger && !isWarning" [class.btn-danger]="isDanger"
        [class.btn-warning]="isWarning" (click)="onConfirm()">
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</div>